const eventsRoutes = {
  path: "events",

  // Lazy-load the layout
  lazy: async () => {
    const mod = await import("components/UI/EventsLayout");
    const EventsLayout = mod.default;
    return { Component: EventsLayout };
  },

  children: [
    {
      index: true,
      lazy: async () => {
        const mod = await import("views/Admin/Events");
        const Events = mod.default;
        return { Component: Events };
      },
    },
    {
      path: "details/:eventId",
      lazy: async () => {
        const mod = await import("views/Admin/Events/EventDetails");
        const EventDetails = mod.default;
        return { Component: EventDetails };
      },
    },
  ],
};

export default eventsRoutes;
